import { IResult } from '../models/HttpResult';
import { ContractIAImportProcess, NewContractIAImportProcess } from '../models/Entities/Contracts/ContractIAImportProcess';
import { apiRequest, buildURL, buildHeaders, handleApiError } from './commons/CommonService.Functions';

const BaseURL = (process.env.REACT_APP_BILLER_API_GATEWAY || '').replace(/\/$/, '') + '/contracts';

// Create IA import process for a contract (POST /contracts/import)
export const CreateImportContractProcess = async (
  command: NewContractIAImportProcess,
  token: string
): Promise<ContractIAImportProcess> => {
  const url = buildURL(BaseURL, 'import');
  return apiRequest<ContractIAImportProcess>(url, token, 'CreateImportContractProcess', {
    method: 'POST',
    body: JSON.stringify(command)
  });
};

// Get last IA import process for a contract (GET /contracts/{ContractId}/import/last)
// Devuelve null si no existe proceso previo (404)
export const GetLastImportContractProcess = async (
  contractId: number,
  token: string
): Promise<ContractIAImportProcess | null> => {
  const url = buildURL(BaseURL, contractId, 'import', 'last');
  try {
    const response = await fetch(url, { headers: buildHeaders(token) });
    if (response.status === 404) return null;
    if (!response.ok) throw response;
    const data: IResult<ContractIAImportProcess> = await response.json();
    return data.data;
  } catch (error: any) {
    const handled = await handleApiError(error, 'GetLastImportContractProcess');
    throw handled;
  }
};

